import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'csf-auth-token',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export type UserRole = 'patient' | 'medecin' | 'super_admin' | 'secretaire' | 'laborantin' | 'sage_femme' | null;

export async function getUserRole(): Promise<UserRole> {
  try {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user) return null;

    const tables: { table: string; role: Exclude<UserRole, null> }[] = [
      { table: 'super_admins', role: 'super_admin' },
      { table: 'medecins', role: 'medecin' },
      { table: 'secretaires', role: 'secretaire' },
      { table: 'patients', role: 'patient' },
      { table: 'laborantins', role: 'laborantin' },
      { table: 'sage_femmes', role: 'sage_femme' },
    ];

    for (const { table, role } of tables) {
      const { data, error } = await supabase
        .from(table)
        .select('*')
        .eq('user_id', user.id)
        .maybeSingle();

      if (error) {
        console.error(`[getUserRole] Error checking ${table}:`, error.message);
        continue;
      }

      if (data) return role;
    }

    return null;
  } catch (error) {
    console.error('[getUserRole] Unexpected error:', error instanceof Error ? error.message : error);
    return null;
  }
}